import { useState } from 'react';
import { useAuthActions } from '@convex-dev/auth/react';
import { FeedbackButton } from './FeedbackButton';
import { DiscordButton } from './DiscordButton';

export function LoggedOutHeaderButtons() {
  const { signIn } = useAuthActions();
  const [showLogin, setShowLogin] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [flow, setFlow] = useState<'signIn' | 'signUp'>('signIn');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await signIn('password', { email, password, flow });
    } catch (err: any) {
      setError(err.message || 'Authentication failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <FeedbackButton showInMenu={false} />
      <DiscordButton showInMenu={false} />
      <button
        onClick={() => setShowLogin(true)}
        className="px-4 py-1.5 rounded-lg bg-bolt-elements-button-primary-background text-bolt-elements-button-primary-text text-sm font-medium hover:bg-bolt-elements-button-primary-backgroundHover"
      >
        Sign In
      </button>
      {showLogin && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm">
          <div className="bg-bolt-elements-background-depth-2 border border-bolt-elements-borderColor rounded-xl p-6 w-full max-w-sm shadow-xl">
            <h2 className="text-bolt-elements-textPrimary text-lg font-semibold mb-4">
              {flow === 'signIn' ? 'Sign In' : 'Create Account'}
            </h2>
            <form onSubmit={handleSubmit} className="flex flex-col gap-3">
              <input
                type="email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="px-3 py-2 rounded-lg bg-bolt-elements-background-depth-3 border border-bolt-elements-borderColor text-bolt-elements-textPrimary text-sm focus:outline-none focus:ring-1 focus:ring-blue-500"
              />
              <input
                type="password"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="px-3 py-2 rounded-lg bg-bolt-elements-background-depth-3 border border-bolt-elements-borderColor text-bolt-elements-textPrimary text-sm focus:outline-none focus:ring-1 focus:ring-blue-500"
              />
              {error && <p className="text-red-400 text-xs">{error}</p>}
              <button
                type="submit"
                disabled={loading}
                className="px-4 py-2 rounded-lg bg-blue-600 text-white text-sm font-medium hover:bg-blue-700 disabled:opacity-50"
              >
                {loading ? 'Loading...' : flow === 'signIn' ? 'Sign In' : 'Create Account'}
              </button>
            </form>
            <div className="mt-3 flex justify-between items-center">
              <button
                onClick={() => { setFlow(flow === 'signIn' ? 'signUp' : 'signIn'); setError(''); }}
                className="text-xs text-bolt-elements-textSecondary hover:text-bolt-elements-textPrimary"
              >
                {flow === 'signIn' ? 'No account? Create one' : 'Have an account? Sign in'}
              </button>
              <button
                onClick={() => { setShowLogin(false); setError(''); }}
                className="text-xs text-bolt-elements-textSecondary hover:text-bolt-elements-textPrimary"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
